import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';
import { Microscope, Award, Users, BookOpen } from 'lucide-react';

const ResearchInnovationPage = () => {
  return (
    <PublicLayout>
      <div className="py-5" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)' }}>
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <Microscope className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Research & Innovation</h1>
              <p className="lead text-muted">
                Advancing respiratory care through cutting-edge research and innovative solutions
              </p>
            </div>
          </div>

          {/* Main Content */}
          <div className="row justify-content-center mb-5">
            <div className="col-lg-10">
              <div className="card shadow border-0">
                <div className="card-body p-4 p-lg-5">
                  <h2 className="h3 fw-bold text-dark mb-4">Our Research Initiatives</h2>
                  <p className="text-muted mb-4">
                    ARCA is committed to supporting and promoting respiratory care research across Africa.
                    We facilitate research collaborations, provide grants and funding opportunities, and
                    publish findings that advance the field of respiratory care.
                  </p>

                  <h3 className="h4 fw-bold text-dark mb-3">Research Focus Areas</h3>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Respiratory Disease Burden:</strong> Studying the prevalence and impact of
                      respiratory diseases in African populations
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Treatment Outcomes:</strong> Evaluating the effectiveness of respiratory
                      care interventions in African settings
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Healthcare Delivery Models:</strong> Developing sustainable models for
                      delivering respiratory care services
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle me-2" style={{ color: '#6B8E23' }}></i>
                      <strong>Technology Innovation:</strong> Adapting and developing appropriate
                      technologies for African healthcare contexts
                    </li>
                  </ul>

                  <h3 className="h4 fw-bold text-dark mb-3">Research Opportunities</h3>
                  <p className="text-muted mb-3">
                    We offer various opportunities for respiratory care professionals and researchers:
                  </p>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-2"><i className="fas fa-arrow-right me-2" style={{ color: '#6B8E23' }}></i>Collaborative Research Projects</li>
                    <li className="mb-2"><i className="fas fa-arrow-right me-2" style={{ color: '#6B8E23' }}></i>Publication Support</li>
                    <li className="mb-2"><i className="fas fa-arrow-right me-2" style={{ color: '#6B8E23' }}></i>Research Training Workshops</li>
                    <li className="mb-2"><i className="fas fa-arrow-right me-2" style={{ color: '#6B8E23' }}></i>Grant Identification and Application Support</li>
                  </ul>

                  <div className="alert" style={{ backgroundColor: '#e8f5e9', borderColor: '#6B8E23', color: '#2c5014' }}>
                    <strong>Coming Soon:</strong> Detailed information about ongoing research projects,
                    grant opportunities, and how to submit your research proposals.
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Get Involved Section */}
          <div className="row g-4 justify-content-center">
            <div className="col-md-5">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <Users className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Collaborate</h5>
                  <p className="text-muted mb-3">Join our research network</p>
                  <Link to="/get-involved/volunteer" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>Join Network</Link>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="card h-100 shadow-sm" style={{ borderColor: '#6B8E23', borderWidth: '2px' }}>
                <div className="card-body text-center p-4">
                  <BookOpen className="mb-3" size={48} style={{ color: '#6B8E23' }} />
                  <h5 className="fw-bold mb-2">Publications</h5>
                  <p className="text-muted mb-3">Read our research publications</p>
                  <Link to="/resources/publications" className="btn fw-bold" style={{ backgroundColor: '#6B8E23', color: 'white' }}>View Publications</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default ResearchInnovationPage;
